<template>
  <div
    class="statistics-beam-takt-sum font-weight-light"
    :style="`
      ${height?`height: ${height}; font-size: calc(${height} - 4px)`:''}
    `"
    >
    <slot/>
  </div>
</template>
<script>
export default {
  props: ['height'],
  data: () => ({
  }),
}
</script>
<style>
  .statistics-beam-takt-sum {
    user-select: none;
    height: calc(24px * var(--taktplan_zoom));
    font-size: calc(16px * var(--taktplan_zoom));
  }
</style>
